import * as React from 'react';
import { AppContext } from '../context/appProvider';
import {
  Categories,
  SeedLevels,
  getFriendlyCategoryName,
  getFriendlySeedLevelName,
  seedRangeOutput,
} from '../typings/data';

import chevronUp from '../assets/chevron-up.svg';
import chevronDown from '../assets/chevron-down.svg';
import { StringHelpers } from '../helpers/stringHelpers';

interface IProps {
  expandable?: boolean;
  isDataPage?: boolean;
}

const FilterList: React.FC<IProps> = ({ expandable, isDataPage }) => {
  const { filterCategories, setFilterCategories } = React.useContext(AppContext);
  const { filterSeedLevels, setFilterSeedLevels } = React.useContext(AppContext);
  const [expanded, setExpanded] = React.useState(!expandable);
  const lowerCaseInvestment = (seedLevel) => StringHelpers.slugToSentence(StringHelpers.toLower(seedLevel));

  React.useEffect(() => {
    if (expandable) {
      const removeFocus = () => setExpanded(false);
      window.addEventListener('click', removeFocus);

      return () => {
        window.removeEventListener('click', removeFocus);
      };
    }
  }, [expanded]);

  return (
    <div className="filters-wrapper" data-expandable={expandable} onClick={(e) => e.stopPropagation()}>
      {expandable && (
        <button onClick={() => setExpanded(!expanded)}>
          Filter companies
          <img alt="Chevron" src={expanded ? chevronUp : chevronDown} />
        </button>
      )}
      {expanded && (
        <div className="filters-list">
          <label className="all-clusters label-main">
            <div className="icon-inner-filters">
              {filterCategories.includes('all') ? (
                <img alt="all" src={`/icons/all-full.svg`} />
              ) : (
                <img alt="all" src={`/icons/all.svg`} />
              )}
            </div>
            <div className="filter-label">ALL CLUSTERS</div>
            <input
              checked={filterCategories.indexOf('all') !== -1}
              onChange={() => setFilterCategories('all')}
              type="checkbox"
            />
          </label>
          <div className="company-sectors">Company sectors</div>
          {Categories.slice().map((c) => (
            <label key={c} className={c}>
              <div className="label-main">
                <div className="icon-inner-filters">
                  {filterCategories.includes(c) ? (
                    <img alt={c} src={`/icons/${c}-full.svg`} />
                  ) : (
                    <img alt={c} src={`/icons/${c}.svg`} />
                  )}
                </div>
                <div className="filter-label">{getFriendlyCategoryName(c)}</div>
                <input
                  checked={filterCategories.indexOf(c) !== -1}
                  onChange={() => setFilterCategories(c)}
                  type="checkbox"
                />
              </div>
              {c === 'fintech' && <div className="category-subheading">including Regtech/Legaltech</div>}
              {c === 'greentech' && <div className="category-subheading">including Cleantech/Climate tech</div>}
            </label>
          ))}
          {isDataPage && <div className="company-sectors">Investment raised</div>}
          {isDataPage &&
            SeedLevels.slice().map((s) => (
              <label key={s} className={s}>
                <div className="label-main">
                  <div className="icon-inner-filters">
                    <img
                      alt={s}
                      className={filterSeedLevels.includes(s) ? 'selected' : ''}
                      src={`/icons/${lowerCaseInvestment(s)}-filter.svg`}
                    />
                  </div>
                  <div className="filter-label">{getFriendlySeedLevelName(s)}</div>
                  <input
                    checked={filterSeedLevels.indexOf(s) !== -1}
                    onChange={() => setFilterSeedLevels(s)}
                    type="checkbox"
                  />
                </div>
                <div className="category-subheading">{seedRangeOutput(s)}</div>
              </label>
            ))}
          <div className="footer-space-data"></div>
        </div>
      )}
    </div>
  );
};

export default FilterList;
